export enum FlowStep {
  SplitScreen = 'start',
  DonationDetails = 'spec',
  PlaceTime = 'place-time',
  AdditionalInformation = 'additional-information',
  Payment = 'confirm',
}
